import React from 'react';
import { TECH_STEPS, TECH_STATS, IMG } from '../mock/mock';

export default function Technology() {
  return (
    <section id="technologia" className="relative bg-[#f5f0e8] overflow-hidden">
      {/* Decorative diagonal accent */}
      <div aria-hidden className="absolute top-32 -left-20 w-96 h-96 rounded-full bg-[#2BA8C0]/[0.05] blur-3xl pointer-events-none" />
      <div aria-hidden className="absolute bottom-40 right-0 w-80 h-80 rounded-full bg-[#0d2336]/[0.05] blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 pt-12 md:pt-16 pb-24 md:pb-32">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start mb-20">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="section-num text-[#2BA8C0] text-2xl">02</span>
              <span className="text-[12px] uppercase tracking-[0.3em] text-[#7a7a7a] font-medium">Technológia</span>
            </div>
            <h2 className="font-serif-display text-4xl md:text-6xl text-[#1a1a1a] leading-[1.05] mb-6">
              Így épül az<br /><span className="italic text-[#2BA8C0]">Eco-Lak otthon</span>
            </h2>
            <p className="text-[#5a5a5a] text-[16px] leading-relaxed mb-10">
              A víz közelsége miatt különös figyelmet fordítunk a páramentesítésre,
              az alapozás vízelvezetésére és a tó-parti adottságokra.
            </p>

            <div className="grid grid-cols-2 gap-4">
              {TECH_STATS.map((s) => (
                <div key={s.label} className="bg-white rounded-2xl p-5 shadow-[0_2px_15px_rgba(13,35,54,0.04)]">
                  <div className="font-serif-display text-3xl md:text-4xl text-[#1a1a1a] mb-1">{s.value}</div>
                  <div className="text-[11px] uppercase tracking-wider text-[#7a7a7a]">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 space-y-4">
            {TECH_STEPS.map((s) => (
              <div
                key={s.num}
                className="group flex gap-5 p-7 rounded-2xl bg-white shadow-[0_2px_15px_rgba(13,35,54,0.04)] hover:shadow-[0_8px_30px_rgba(13,35,54,0.08)] transition-all"
              >
                <span className="section-num text-[#2BA8C0] text-3xl shrink-0 leading-none">{s.num}</span>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2 gap-4">
                    <h3 className="font-serif-display text-2xl text-[#1a1a1a]">{s.title}</h3>
                  </div>
                  <p className="text-[#5a5a5a] text-[14px] leading-relaxed">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Full-width image strip with top fade */}
      <div className="relative w-full aspect-[16/5] md:aspect-[16/4] overflow-hidden">
        <img src={IMG.roof_beams} alt="Építés" className="w-full h-full object-cover" />
        <div className="absolute inset-x-0 top-0 h-2/3 bg-gradient-to-b from-[#f5f0e8] via-[#f5f0e8]/80 to-transparent pointer-events-none" />
      </div>
    </section>
  );
}
